import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslationService } from '../../services/translation.service';
import { TranslatePipe } from '../../pipes/translate.pipe';

interface Language {
  code: string;
  nameKey: string;
}

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  templateUrl: './language-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe]
})
export class LanguageSwitcherComponent {
  private translationService = inject(TranslationService);
  
  languages: Language[] = [
    { code: 'en', nameKey: 'lang.en' },
    { code: 'th', nameKey: 'lang.th' },
  ];
  
  currentLang = this.translationService.currentLang;

  switchLanguage(event: Event): void {
    const lang = (event.target as HTMLSelectElement).value;
    this.translationService.use(lang);
  }
}
